import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { DASHBOARD_ROUTE, SIGNIN_ROUTE } from "../../constants/RoutePath";
import { WEB_ENCRYPTION_URL } from "../../constants/ApiRoute";
import API from "./API";
import CryptoJS from "crypto-js";
import { get } from "underscore";
import { getLogUserRole } from "./MainFunction";
import { useEffect, useState } from "react";
import JSZip from "jszip";
import { saveAs } from "file-saver";

// Buffer the master key and IV

const key2 = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_MASTER_KEY);
const iv2 = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_IV);

export function enCryptFun(text) {
  try {
    // Encrypt the text using AES-256-CBC
    const encrypted = CryptoJS.AES.encrypt(text, key2, {
      iv: iv2,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    const encryptedHex = encrypted.ciphertext.toString(CryptoJS.enc.Hex);
    return encryptedHex;
  } catch (error) {
    console.error("Encryption error:", error);
  }
}

export function deCryptFun(encryptedHex) {
  console.log(encryptedHex,'encryyyyyyyyyyyyyyyy')
  if(encryptedHex){
  try {
    console.log("Step 1: Parsing Hex/Base64:", encryptedHex);
    // Convert the encrypted hex string back to a CipherParams object
    const encryptedCipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Hex.parse(encryptedHex),
    });
    console.log("Step 2: CipherParams Object:", encryptedCipherParams);
    // Decrypt the text using AES-256-CBC
    const decrypted = CryptoJS.AES.decrypt(encryptedCipherParams, key2, {
      iv: iv2,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    console.log("Step 3: Decrypted Raw:", decrypted);
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    console.log("Step 4: Final Decrypted Text:", decryptedText);
    return decryptedText;
  } catch (error) {
    console.error("Decryption error:", error);
  }
}
}

export function PublicRoute({ children }) {
  const token = localStorage.getItem("AUTH_TOKEN");
  const user = getLogUserRole();
  return !token ? (
    children
  ) : user.includes("Admin") ? (
    <Navigate to="/dashboard" />
  ) : (
    <Navigate to="/daily-entry" />
  );
}

const locationParams = (search) => {
  var searchParams = new URLSearchParams(search);
  let ob = {};
  searchParams.forEach(function (value, key) {
    ob[key] = value;
  });
  return ob;
};
// export function PrivateRoute({ children }) {
//   const token = localStorage.getItem("AUTH_TOKEN");
//   const location = useLocation();
//   return token ? (
//     children
//   ) : (
//     <Navigate to={SIGNIN_ROUTE} state={{ from: location.pathname }} />
//   );
// }
export function PrivateRoute({ children, allowedRoles }) {
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("AUTH_TOKEN")
  );
  const [userRole, setUserRole] = useState([]);
  const location = useLocation();
    const normalizeRoles = (value) => {
    if (Array.isArray(value)) return value;
    if (typeof value !== "string") return [];

    const trimmed = value.trim();
    if (!trimmed) return [];

    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) {
        return parsed.map((role) => String(role).trim()).filter(Boolean);
      }
    } catch (error) {
      // Fall back to comma-separated/plain string parsing.
    }

    return trimmed
      .split(",")
      .map((role) => role.replace(/^\[|\]$/g, "").replace(/"/g, "").trim())
      .filter(Boolean);
  };


  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "AUTH_TOKEN") {
        setIsAuthenticated(!!event.newValue);
      }
      if (event.key === "ROLE") {
        const encryptedRoles = event.newValue;
        if (encryptedRoles) {
          setUserRole(JSON.parse(deCryptFun(encryptedRoles)));
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    const encryptedRoles = localStorage.getItem("ROLE");
    if (encryptedRoles) {
      setUserRole(JSON.parse(deCryptFun(encryptedRoles)));
    }
  }, []);


  if (!isAuthenticated) {
    return <Navigate to={SIGNIN_ROUTE} state={{ from: location.pathname }} />;
  }

  const storedRoles = getLogUserRole();
  const resolvedRoles =
    Array.isArray(userRole) && userRole.length > 0
      ? userRole
      : normalizeRoles(storedRoles);
  const userRole1 = resolvedRoles.join(",");

  if (allowedRoles && !allowedRoles.some((role) => resolvedRoles.includes(role))) {
    if (userRole1.includes("Admin")) {
      if (location.pathname == "/") {
        localStorage.setItem('LOG_SIDE_INDEX', '0')
        return <Navigate to="/dashboard" />;
     
      } else {
        return <Navigate state={{ from: location.pathname }} />;
      }
    } else {
      return <Navigate to="/daily-entry" />;
    }
  }

  return children;
}
// export const CustomMessage = (message, variant, enqueueSnackbar) => {
//     enqueueSnackbar(message, {
//       anchorOrigin: {
//         vertical: "top",
//         horizontal: "right",
//       },
//       ContentProps: {
//         style: {
//           borderBottom: `4px solid ${
//             variant === "success" ? "#4caf50" : "#f44336"
//           }`,
//           backgroundColor: "#fff", // Ensure background color is white
//           // color: "#000",
//           fontSize: "1.2rem",
//           fontWeight: "bold",
//           padding: "16px",
//           boxShadow:
//             "0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)",
//         },
//       },
//     });
//   };

export const enCryptFunWeb = async (data) => {
  const config = {
    method: "POST",
    url: WEB_ENCRYPTION_URL,
    data: data,
  };
  try {
    const response = await API(config);
    return response.data;
  } catch (error) {}
};
export const deCryptFunWeb = async (data) => {
  const config = {
    method: "POST",
    url: WEB_ENCRYPTION_URL,
    data: data,
  };
  try {
    const response = await API(config);
    return response.data;
  } catch (error) {}
};

export const zipAndDownload = async (data) => {
  for (let i = 0; i < data?.length; i++) {
    const path = data[i].Path;
    setTimeout(() => {
      const anchor = document.createElement("a");
      anchor.href = path;
      anchor.download = path.split("/").pop();
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    }, i * 2000);
  }

  /*
  const zip = new JSZip();
  const promises = data.map(async (item, index) => {

    const headers = new Headers({
      'Access-Control-Allow-Origin': 'http://localhost:3000',
      'Content-Type': 'application/json'
    });

    const response = await fetch(item.Path, {
      mode: 'no-cors',
      headers: headers
    });
    
    const blob = await response.blob();
    zip.file(`${item.FileName}`, blob);
  });

  await Promise.all(promises);

  zip.generateAsync({ type: "blob" })
    .then(blob => {
      saveAs(blob, "files.zip");
    })
    .catch(err => console.error("Error zipping files:", err));
    */
};
